import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MainDataService {
  baseUrl: string;
  browserLanguge:any;
  private _cartItemshData = new BehaviorSubject<any>([]);
  private _cartLengthData = new BehaviorSubject<any>(null);
  private _userData = new BehaviorSubject<any>(null);


  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = `${environment.apiEndPoint}`;


  }

  getAllCategories(): Observable<object> {
    return this.http.get(`${this.baseUrl}/Product/Category/GetCategoriesForUser?PageSize=1000&IsActive=${true}`);
  }

  getInitialData(): Observable<object> {
    return this.http.get(`${this.baseUrl}/Tenant/ThemeKeyConfiguration/GetInitialData`);
  }

  getConfigurationData(): Observable<object> {
    return this.http.get(`${this.baseUrl}/Tenant/Configuration/GetAllConfiguration`);
  }

  getAllCountryTenants(): Observable<object> {
    const excludingTenants: any = environment.excludingTenants || [];
    return this.http.get(`${this.baseUrl}/Auth/CountryTenant/GetAllCountryTenants?Referer=${environment.referer}`).pipe(map((res: any) => {
      res.data.records = res.data.records.filter((x: any) => !excludingTenants.includes(x.id))
      return res;
    }));
  }

  setCartItemsData(data: any) {
    this._cartItemshData.next(data);
  }

  getCartItemsData(): any {
    return this._cartItemshData;
  }

  setCartLenghtData(data: any) {
    this._cartLengthData.next(data);
  }

  getCartLengthData(): any {
    return this._cartLengthData;
  }

  setUserData(data: any) {
    this._userData.next(data);
  }

  getUserData(): any {
    return this._userData;
  }

  getTenantShowRoomConfiguration(): Observable<any> {
    return this.http.get(`${this.baseUrl}/Tenant/ShowRoomConfiguration/GetTenantShowRoomConfiguration`);
  }
}
